// MainPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { Link } from 'react-router-dom';
import { get_users, get_logs } from '../api/api.js';
import TitleBackButton from '../components/TitleBackButton';


const LogsPage = () => {

  const [ users, setUsers] = useState([]);
  const [ logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);


  const translate = (str)=>{
      const translations = {
        "rockfall":"Barriera",
        "tag":"Etichetta NFC",
        "maintenance":"Intervento",
        "document":"Documento",
        "installation_document":"Certificato corretta posa",
        "maintenance_document":"Documento di manutenzione",

        "delete":"Cancellazione",
        "create":"Creazione",
        "update":"Modifica",
      };
      if(translations[str]) return translations[str];
      return "-";
  }

  const retrieveData = async () => {
    try{
        const get_the_users = async () => {
            const res = await get_users();
            const data = res && res.data && res.data.results ? res.data.results : [];
            setUsers(data);     // Set state with resolved data
        };
        const get_the_logs = async () => {
            const res = await get_logs();
            const data = res && res.data && res.data.results ? res.data.results : [];

            data.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.timestamp) - new Date(a.timestamp);
            });

            setLogs(data);     // Set state with resolved data
        };
        await get_the_users();
        await get_the_logs();
      }
      catch(error){
            console.error(error);
      }
      finally {
            setLoading(false); // Set loading to false after the fetch is complete
      }
  }

  useEffect( () => {
      retrieveData();
  }, []);



  return (
    <div>
      <TopBar />

      <div className="content">

            <TitleBackButton
              title={"Registro Operazioni"}
            />

        <div className="main-content">




          {loading ? (
              <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
          ) : (
              <table className="log-table">
                  <tbody>
                  <th>Utente</th>
                  <th>Oggetto</th>
                  <th>Nome</th>
                  <th>Azione</th>
                  <th>Data</th>
                      {logs.map((object, i) => {
                          const user = users.find(e => e.id === object.user);
                          return (
                              <tr key={i}>
                                  <td>{user?.first_name} {user?.last_name}</td>
                                  <td>{translate(object.model)}</td>
                                  <td>{object.name}</td>
                                  <td>{translate(object.action)}</td>
                                  <td>{object.timestamp}</td>
                              </tr>
                          );
                      })}
                  </tbody>
              </table>
          )}

        </div>

      </div>
    </div>
  );
};

export default LogsPage;
